import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout } from 'entities/ExportRouters'
import { SettingsPath } from 'pages/settings/route/settingsPath'

export const ComplianceAccessRootLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.compliance_settings}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          path: `/${SettingsPath.personal.profile}`,
        })
      }}
    />
  )
})
